import { brandTheme } from '@homestake/shared/theme';
import {
  mergeThemeOverrides,
  MantineProvider as Provider,
} from '@mantine/core';
import type { ReactNode } from 'react';

const newTheme = mergeThemeOverrides(brandTheme, {
  breakpoints: {
    xs: '36rem',
    sm: '40rem',
    md: '48rem',
    lg: '57rem',
    xl: '80rem',
  },
});

export const MantineProvider = ({ children }: { children: ReactNode }) => {
  return (
    <Provider forceColorScheme="dark" theme={newTheme}>
      {children}
    </Provider>
  );
};
